<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="role == 'admn' || role == 'anly'">
      <upload-malware
        @finish-upload="finishUpload"
        @doSearch="doSearchAfterUpload"
      ></upload-malware>
      <queue-analysis :runQueue="runqueue"></queue-analysis>
    </div>

    <!-- <history-upload /> -->

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body p-3">
            <div class="card-title text-center">
              <h4>{{ $t("malware.malware-search") }}</h4>
            </div>
            <p class="card-title-desc text-center">
              {{ $t("malware.analyse") }}
            </p>
            <div class="search-form px-5">
              <div class="row">
                <div class="col-xl-8 col-lg-6 col-md-4 mb-3">
                  <input
                    v-model="form.searchKey"
                    v-on:keyup.enter="dummySearch"
                    type="text"
                    class="form-control"
                    placeholder="Search name, hash, or IP Address .."
                  />
                </div>
                <div class="col-xl-4 col-lg-6 col-md-8">
                  <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-6 col-sm-4 mb-3">
                      <select class="custom-select" v-model="sandbox_value">
                        <option value="all">
                          {{ $t("malware.all-sandbox") }}
                        </option>
                        <option value="1">Checkpoint</option>
                        <option value="2">AhnLab</option>
                      </select>
                    </div>
                    <div class="col-xl-4 col-lg-3 col-md-3 col-sm-6 mb-3">
                      <b-button
                        variant="primary"
                        class="btn-block"
                        @click="dummySearch"
                        v-on:keyup.enter="dummySearch"
                      >
                        <i class="bx bx-search font-size-16 align-middle"></i>
                        <span class="d-xl-inline d-lg-none d-md-none">{{
                          $t("malware.search")
                        }}</span>
                      </b-button>
                    </div>
                    <div class="col-xl-4 col-lg-3 col-md-3 col-sm-2 mb-3">
                      <b-button
                        variant="primary"
                        class="btn-block"
                        v-b-toggle="'advanced-search'"
                      >
                        <i class="bx bx-filter font-size-16 align-middle"></i>
                        <span
                          class="d-xl-inline d-lg-none d-md-none d-sm-none"
                          >{{ $t("malware.advanced") }}</span
                        >
                      </b-button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <b-collapse id="advanced-search" class="mt-1">
                    <hr class="mt-4 mb-0" />
                    <div class="py-4">
                      <div class="row">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                          <div class="form-group">
                            <label for="validationCustom01">{{
                              $t("malware.file-name")
                            }}</label>
                            <input
                              id="validationCustom01"
                              type="text"
                              class="form-control"
                              placeholder="example.exe"
                              v-model="form.advanced.file_name"
                            />
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                          <div class="form-group">
                            <label for="validationCustom01">{{
                              $t("malware.threat-name")
                            }}</label>
                            <input
                              id="validationCustom01"
                              type="text"
                              class="form-control"
                              placeholder="Trojan.mW"
                              v-model="form.advanced.threat_name"
                            />
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                          <div class="form-group">
                            <label for="validationCustom01">{{
                              $t("malware.file-type")
                            }}</label>
                            <input
                              id="validationCustom01"
                              type="text"
                              class="form-control"
                              placeholder="exe"
                              v-model="form.advanced.file_type"
                            />
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                          <div class="form-group">
                            <label for="validationCustom01">{{
                              $t("malware.ip-address")
                            }}</label>
                            <input
                              id="validationCustom01"
                              type="text"
                              class="form-control"
                              placeholder="10.10.xx.xxx"
                              v-model="form.advanced.ip_address"
                            />
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                          <div class="form-group">
                            <label for="validationCustom01">MD5</label>
                            <input
                              id="validationCustom01"
                              type="text"
                              class="form-control"
                              placeholder="c0d5b1cc0c77fcf32ff02aac98fac536"
                              v-model="form.advanced.md5"
                            />
                          </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                          <div class="form-group">
                            <label for="validationCustom01">SHA-1</label>
                            <input
                              id="validationCustom01"
                              type="text"
                              class="form-control"
                              placeholder="2154845e38fc348ae1be419684f9572a680fabfd"
                              v-model="form.advanced.sha1"
                            />
                          </div>
                        </div>
                        <div class="col-12 text-right">
                          <b-button
                            variant="primary"
                            class="px-5"
                            @click="dummyAdvancedSearch"
                          >
                            <i
                              class="bx bx-search font-size-16 align-middle mr-2"
                            ></i>
                            {{ $t("malware.search") }}
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading text-center py-5 my-5" v-if="loading.search">
      <div class="text-center">
        <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
        <span class="font-size-16"> {{ $t("malware.searching") }} </span>
      </div>
    </div>
    <div v-if="isSearch">
      <div class="card" v-if="sandbox_value == '1' || sandbox_value == 'all'">
        <div class="card-body">
          <div class="card-title">
            <div class="d-flex">
              <div class="">
                <h4>Checkpoint Result</h4>
                <p class="font-size-12 font-weight-normal">
                  {{ searchResult1.length }} result found
                </p>
              </div>
            </div>
          </div>

          <div class="" v-if="searchResult1.length != 0">
            <div v-for="(sr1, id) in searchResult1" :key="id">
              <div
                class="d-block rounded border border-light mb-5"
                :class="theme == 'dark' ? 'border-primary' : 'border-light'"
              >
                <div class="row">
                  <div class="col-lg-12">
                    <div
                      class="d-block rounded px-2"
                      :class="theme == 'dark' ? '' : 'bg-light'"
                    >
                      <div
                        class="d-flex justify-content-between align-items-center px-2"
                      >
                        <h5
                          class="mb-0"
                          :class="theme == 'dark' ? 'text-white' : ''"
                        >
                          Hash :
                          {{ sr1._source.md5 }}
                        </h5>
                        <span> </span>
                        <b-button
                          size="sm"
                          :variant="theme == 'dark' ? 'transparent' : 'light'"
                          class="rounded"
                          v-b-toggle="'detail-checkpoint' + id"
                        >
                          <i
                            class="bx bx-chevron-down bx-sm font-size-16 align-middle"
                          ></i>
                        </b-button>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 py-2">
                    <div class="row px-2">
                      <div class="col-lg-12 px-4">
                        <label
                          for=""
                          :class="theme == 'dark' ? 'text-white' : ''"
                          >Threat Name</label
                        >
                        <p>
                          {{
                            sr1._source.av.malware_info
                              ? sr1._source.av.malware_info.signature_name
                              : "-"
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 py-2">
                    <div class="row px-2">
                      <div class="col-3"></div>
                      <div class="col-3">
                        <label
                          for=""
                          :class="theme == 'dark' ? 'text-white' : ''"
                          >File Size</label
                        >
                        <p>
                          {{
                            detailInfo.length != 0 && detailInfo[id].tech_detail
                              ? formatByte(detailInfo[id].tech_detail.file_size)
                              : "-"
                          }}
                        </p>
                      </div>
                      <!-- <div class="col-3">
                        <label for="">Index Time</label>
                        <p class="mb-0">{{ sr1._source.index_time }}</p>
                        <p class="font-italic mb-0">2 Year Ago</p>
                      </div> -->
                      <div class="col-3">
                        <label
                          for=""
                          :class="theme == 'dark' ? 'text-white' : ''"
                          >File Type</label
                        >
                        <p>{{ sr1._source.file_type }}</p>
                      </div>
                      <div class="col-3 mb-2">
                        <div class="avatar-md">
                          <span
                            class="avatar-title rounded-circle bg-light text-danger font-size-16"
                          >
                            <img
                              :src="
                                require('@/assets/images/file-type/' +
                                  getFileTypeIcon(sr1._source.file_type))
                              "
                              alt
                              height="40"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <b-collapse :id="'detail-checkpoint' + id" class="mt-1">
                  <div class="row mb-3">
                    <div class="col-lg-12 mb-3">
                      <div
                        class="d-block rounded mt-3 h-100"
                        :class="theme == 'dark' ? '' : 'border-light'"
                      >
                        <b-tabs
                          nav-class="nav-tabs-custom"
                          content-class="p-3 text-muted"
                        >
                          <b-tab active>
                            <template v-slot:title>
                              <span class="d-inline-block d-sm-none">
                                <i class="bx bx-detail"></i>
                              </span>
                              <span class="d-none d-sm-inline-block mx-5 my-2"
                                >Details</span
                              >
                            </template>
                            <div class="card-body p-0 py-3">
                              <h5 class="py-1 px-2">DETAIL INFORMATION</h5>
                              <hr />
                              <div class="row">
                                <div class="col-4"></div>
                              </div>
                              <div class="table-responsive">
                                <table
                                  class="table mb-0"
                                  style="border-top: none"
                                >
                                  <tbody>
                                    <tr class="text-white">
                                      <th colspan="2" style="border-top: none">
                                        <h5>Basic Properties</h5>
                                      </th>
                                    </tr>
                                    <tr>
                                      <td width="20%" class="font-weight-bold">
                                        MD5
                                      </td>
                                      <td>
                                        {{ sr1._source.md5 }}
                                        <button
                                          class="btn btn-transparent"
                                          title="Copy"
                                          @click="copyText(sr1._source.md5)"
                                        >
                                          <i
                                            class="ml-1 text-primary bx bx-copy"
                                          ></i>
                                        </button>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">SHA-1</td>
                                      <td>
                                        {{ sr1._source.sha1 }}
                                        <button
                                          class="btn btn-transparent"
                                          title="Copy"
                                          @click="copyText(sr1._source.sha1)"
                                        >
                                          <i
                                            class="ml-1 text-primary bx bx-copy"
                                          ></i>
                                        </button>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">SHA-256</td>
                                      <td>
                                        {{ sr1._source.sha256 }}
                                        <button
                                          class="btn btn-transparent"
                                          title="Copy"
                                          @click="copyText(sr1._source.sha256)"
                                        >
                                          <i
                                            class="ml-1 text-primary bx bx-copy"
                                          ></i>
                                        </button>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">
                                        File Type
                                      </td>
                                      <td>{{ sr1._source.file_type }}</td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">
                                        File Size
                                      </td>
                                      <td>
                                        {{
                                          detailInfo.length != 0 &&
                                          detailInfo[id].tech_detail
                                            ? formatByte(
                                                detailInfo[id].tech_detail
                                                  .file_size
                                              ) +
                                              " ( " +
                                              (detailInfo[id].tech_detail
                                                .file_size
                                                ? detailInfo[id].tech_detail
                                                    .file_size
                                                : "0") +
                                              " Byte )"
                                            : "-"
                                        }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div class="mt-5 pb-3">
                                <h5>Information On Execution</h5>
                                <hr />
                                <div class="row">
                                  <div class="col-4"></div>
                                </div>
                                <table
                                  class="table mb-0"
                                  style="border-top: none"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        width="20%"
                                        class="font-weight-bold"
                                        style="border-top: none"
                                      >
                                        Start Execution
                                      </td>
                                      <td style="border-top: none">
                                        {{
                                          formatDetectTime(
                                            sr1._source.detect_time
                                          )
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">
                                        Finish Execution
                                      </td>
                                      <td>
                                        {{ sr1._source.analysis_time }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">
                                        File Name
                                      </td>
                                      <td>
                                        {{ sr1._source.file_name }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">
                                        Threat Name
                                      </td>
                                      <td>
                                        {{
                                          sr1._source.av.malware_info
                                            ? sr1._source.av.malware_info
                                                .signature_name
                                            : "-"
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">
                                        Classification
                                      </td>
                                      <td>
                                        <div
                                          class=""
                                          v-if="
                                            detailInfo.length != 0 &&
                                            detailInfo[id].classification
                                          "
                                        >
                                          <span
                                            class="badge badge-primary mr-2 px-2 py-1"
                                            v-for="(cl, idcl) in detailInfo[id]
                                              .classification"
                                            :key="idcl"
                                            >{{ cl }}</span
                                          >
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">Severity</td>
                                      <td>
                                        {{ sr1._source.te.severity }} ({{
                                          detailInfo.length != 0 &&
                                          detailInfo[id].general_res
                                            ? detailInfo[id].general_res
                                                .Severity
                                            : ""
                                        }})
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </b-tab>
                          <b-tab>
                            <template v-slot:title>
                              <span class="d-inline-block d-sm-none">
                                <i class="bx bx-sitemap"></i>
                              </span>
                              <span class="d-none d-sm-inline-block mx-5 my-2"
                                >Relations</span
                              >
                            </template>
                            <div class="card-body p-0 py-3">
                              <h5 class="py-1 px-2">RELATED INFORMATION</h5>
                              <hr />
                              <div class="row px-3">
                                <div
                                  class="col-12 border border-left-0 border-right-0 border-top-0 py-3"
                                >
                                  <h5>Connected IP Address</h5>
                                </div>
                                <div class="col-12">
                                  <p class="mt-5 text-center">Data not found</p>
                                </div>
                              </div>
                              <!-- <div class="row mt-5 px-3">
                                <div
                                  class="col-12 border border-left-0 border-right-0 border-top-0 py-3"
                                >
                                  <h5>Related Files</h5>
                                </div>
                                <div class="col-12">
                                  <p class="mt-5 text-center">Data not found</p>
                                </div>
                              </div> -->
                            </div>
                          </b-tab>

                          <b-tab>
                            <template v-slot:title>
                              <span class="d-inline-block d-sm-none">
                                <i class="bx bx-sitemap"></i>
                              </span>
                              <span class="d-none d-sm-inline-block mx-5 my-2"
                                >Screen Capture</span
                              >
                            </template>
                            <div class="card-body p-0 py-3">
                              <h5 class="py-1 px-2">SCREEN CAPTURE</h5>
                              <hr />
                              <div
                                class="row"
                                v-if="
                                  detailInfo.length != 0 &&
                                  detailInfo[id].emu_videos &&
                                  detailInfo[id].emu_videos.length != 0
                                "
                              >
                                <div
                                  class="col-3 p-4"
                                  v-for="(ev, idev) in detailInfo[id]
                                    .emu_videos"
                                  :key="idev"
                                >
                                  <span class="my-2">{{ ev.image_name }}</span>
                                  <span @click="modalImage()">
                                    <video width="100%" class="my-3" controls>
                                      <source
                                        :src="
                                          sc_url_cp +
                                          'md5=' +
                                          sr1._source.md5 +
                                          '&path=' +
                                          ev.url
                                        "
                                        type="video/mp4"
                                      />
                                      Your browser does not support the video
                                      tag.
                                    </video>
                                  </span>
                                </div>
                              </div>
                              <div class="row" v-else>
                                <div class="col-12">
                                  <p class="mt-5 text-center">Data not found</p>
                                </div>
                              </div>
                            </div>
                          </b-tab>

                          <b-tab>
                            <template v-slot:title>
                              <span class="d-inline-block d-sm-none">
                                <i class="bx bx-sitemap"></i>
                              </span>
                              <span class="d-none d-sm-inline-block mx-5 my-2"
                                >Suspicious Activities</span
                              >
                            </template>
                            <div class="card-body p-0">
                              <div
                                class="d-flex justify-content-between align-items-center py-1 px-2"
                              >
                                <h5 class="py-1">SUSPICIOUS ACTIVITIES</h5>
                                <div
                                  class="d-flex justify-content-end align-items-center"
                                  style="width: 20%"
                                >
                                  <span for="" class="mr-2">Running On : </span>
                                  <select
                                    style="width: 50%; float: right"
                                    class="form-control"
                                    v-model="cp_susact_vm[sr1._source.md5]"
                                    @change="changeCpSusactVm(sr1._source.md5)"
                                  >
                                    <option
                                      v-for="(
                                        optVm, idOpt
                                      ) in detailInfo.length != 0
                                        ? detailInfo[id].suspicious_act.images
                                        : []"
                                      :key="idOpt"
                                      :value="sr1._source.md5 + '_' + idOpt"
                                    >
                                      {{ optVm.image }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <hr />
                              <div class="row mt-4">
                                <div class="col-sm-12 col-md-6">
                                  <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                  >
                                    <label
                                      class="d-inline-flex align-items-center"
                                    >
                                      {{ $t("table.show_label") }}&nbsp;&nbsp;
                                      <b-form-select
                                        v-model="perPage"
                                        size="sm"
                                        :options="pageOptions"
                                        class="mx-1"
                                      ></b-form-select
                                      >&nbsp;&nbsp;{{ $t("table.entri_label") }}
                                    </label>
                                  </div>
                                </div>
                                <!-- Search -->
                                <div class="col-sm-12 col-md-6">
                                  <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-right"
                                  >
                                    <label
                                      class="d-inline-flex align-items-center"
                                    >
                                      {{ $t("table.search_label") }}:
                                      <b-form-input
                                        v-model="filter"
                                        type="search"
                                        :placeholder="$t('navbar.search.text')"
                                        class="form-control form-control-sm ml-2"
                                      ></b-form-input>
                                    </label>
                                  </div>
                                </div>
                                <!-- End search -->
                              </div>
                              <div class="table-responsive mb-0">
                                <div
                                  class="text-center mt-5"
                                  v-if="loading.change_cp_susact_vm"
                                >
                                  <i
                                    class="bx bx-loader-circle bx-spin bx-md"
                                  ></i>
                                  <h5>Loading....</h5>
                                </div>
                                <b-table
                                  v-if="!loading.change_cp_susact_vm"
                                  :items="
                                    cp_table_susact[sr1._source.md5]
                                      ? cp_table_susact[sr1._source.md5].data
                                      : []
                                  "
                                  :fields="fields_cp"
                                  responsive="sm"
                                  :per-page="perPage"
                                  :current-page="currentPage"
                                  :sort-desc.sync="sortDesc"
                                  :filter="filter"
                                  :filter-included-fields="filterOn"
                                  @filtered="onFiltered"
                                  show-empty
                                >
                                  <template #cell(no)="row">
                                    {{ row.item.no + 1 }}
                                  </template>
                                  <template #empty="scope">
                                    <p class="mt-5 text-center">
                                      Data not found
                                    </p>
                                  </template>
                                </b-table>
                              </div>
                              <div
                                class="row"
                                v-if="
                                  !loading.change_cp_susact_vm &&
                                  rowscp(cp_susact_vm[sr1._source.md5]) > 10
                                "
                              >
                                <div class="col-2">
                                  <label
                                    class="d-inline-flex align-items-center"
                                  >
                                    Page
                                    <b-form-input
                                      v-model="currentPage"
                                      placeholder="Page"
                                      class="form-control w-10 form-control ml-2"
                                    ></b-form-input>
                                  </label>
                                </div>
                                <div
                                  class="col-10 text-right"
                                  v-if="
                                    rowscp(cp_susact_vm[sr1._source.md5]) > 10
                                  "
                                >
                                  <div
                                    class="dataTables_paginate paging_simple_numbers float-right"
                                  >
                                    <ul
                                      class="pagination pagination-rounded mb-0"
                                      :class="
                                        theme == 'dark'
                                          ? 'custom-paginate-dark'
                                          : 'custom-paginate'
                                      "
                                    >
                                      <b-pagination
                                        v-model="currentPage"
                                        :total-rows="
                                          rowscp(cp_susact_vm[sr1._source.md5])
                                        "
                                        :per-page="perPage"
                                      ></b-pagination>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-tab>
                        </b-tabs>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
          <div class="py-4" v-else>
            <div class="text-center">
              <img
                src="@/assets/images/no-results.png"
                alt
                height="150"
              /><br />
              <span class="font-size-16"> Not Found </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="card mt-4"
        v-if="sandbox_value == '2' || sandbox_value == 'all'"
      >
        <div class="card-body">
          <div class="card-title">
            <div class="d-flex">
              <div class="">
                <h4>AhnLab Result</h4>
                <p class="font-size-12 font-weight-normal">
                  {{ searchResult2.length }} result found
                </p>
              </div>
            </div>
          </div>
          <div class="" v-if="Object.keys(searchResult2).length != 0">
            <div v-for="(sr2, id) in searchResult2" :key="id">
              <div
                class="d-block rounded border mb-5"
                :class="theme == 'dark' ? '' : 'border-light'"
              >
                <div class="row">
                  <div class="col-lg-12">
                    <div
                      class="d-block rounded px-2"
                      :class="theme == 'dark' ? '' : 'bg-light'"
                    >
                      <div
                        class="d-flex justify-content-between align-items-center px-2"
                      >
                        <h5
                          class="mb-0"
                          :class="theme == 'dark' ? 'text-white' : ''"
                        >
                          Hash :
                          {{ sr2[0]._source.md5sum }}
                        </h5>
                        <span> </span>
                        <b-button
                          size="sm"
                          :variant="theme == 'dark' ? 'transparent' : 'light'"
                          class="rounded"
                          v-b-toggle="'detail-ahnlab' + id"
                        >
                          <i
                            class="bx bx-chevron-down bx-sm font-size-16 align-middle"
                          ></i>
                        </b-button>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 py-2">
                    <div class="row px-2">
                      <div class="col-lg-12 px-4">
                        <label
                          for=""
                          :class="theme == 'dark' ? 'text-white' : ''"
                          >Threat Name</label
                        >
                        <p>{{ sr2[0]._source.detect_name }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 py-2">
                    <div class="row px-2">
                      <div class="col-3"></div>
                      <div class="col-3">
                        <label
                          for=""
                          :class="theme == 'dark' ? 'text-white' : ''"
                          >File Size</label
                        >
                        <p>{{ formatByte(sr2[0]._source.file_size) }}</p>
                      </div>
                      <div class="col-3">
                        <label
                          for=""
                          :class="theme == 'dark' ? 'text-white' : ''"
                          >File Type</label
                        >
                        <p>
                          {{
                            sr2[0]._source.file_type
                              ? sr2[0]._source.file_type
                              : "Unknown"
                          }}
                        </p>
                      </div>
                      <div class="col-3 mb-2">
                        <div class="avatar-md">
                          <span
                            class="avatar-title rounded-circle bg-light text-danger font-size-16"
                          >
                            <img
                              :src="
                                require('@/assets/images/file-type/' +
                                  getFileTypeIcon(sr2[0]._source.file_type))
                              "
                              alt
                              height="40"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <b-collapse :id="'detail-ahnlab' + id" class="mt-1">
                  <div class="row mb-3">
                    <div class="col-lg-12 mb-3">
                      <div
                        class="d-block rounded mt-3 h-100"
                        :class="theme == 'dark' ? '' : 'border-light'"
                      >
                        <b-tabs
                          nav-class="nav-tabs-custom"
                          content-class="p-3 text-muted"
                        >
                          <b-tab active>
                            <template v-slot:title>
                              <span class="d-inline-block d-sm-none">
                                <i class="bx bx-detail"></i>
                              </span>
                              <span class="d-none d-sm-inline-block mx-5 my-2"
                                >Details</span
                              >
                            </template>
                            <div class="card-body p-0 py-3">
                              <h5 class="py-1 px-2">DETAIL INFORMATION</h5>
                              <hr />
                              <div class="row">
                                <div class="col-4"></div>
                              </div>
                              <div class="table-responsive">
                                <table
                                  class="table mb-0"
                                  style="border-top: none"
                                >
                                  <tbody>
                                    <tr class="text-white">
                                      <th colspan="2" style="border-top: none">
                                        <h5>Basic Properties</h5>
                                      </th>
                                    </tr>
                                    <tr>
                                      <td width="20%" class="font-weight-bold">
                                        MD5
                                      </td>
                                      <td>
                                        {{ sr2[0]._source.md5sum }}
                                        <button
                                          class="btn btn-transparent"
                                          title="Copy"
                                          @click="
                                            copyText(sr2[0]._source.md5sum)
                                          "
                                        >
                                          <i
                                            class="ml-1 text-primary bx bx-copy"
                                          ></i>
                                        </button>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">SHA-1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">SHA-256</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">
                                        File Type
                                      </td>
                                      <td>{{ sr2[0]._source.file_type }}</td>
                                    </tr>
                                    <tr>
                                      <td class="font-weight-bold">
                                        File Size
                                      </td>
                                      <td>
                                        {{
                                          formatByte(sr2[0]._source.file_size)
                                        }}
                                        ( {{ sr2[0]._source.file_size }} Byte )
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div class="mt-5 px-3 pb-3">
                                <h5>Information On Execution</h5>
                              </div>
                              <b-tabs justified content-class="py-3 text-muted">
                                <b-tab
                                  class="border-0"
                                  v-for="(ioe, ioeidx) in sr2"
                                  :key="ioeidx"
                                  :active="ioeidx == 0"
                                >
                                  <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                      <i class="fas fa-home"></i>
                                    </span>
                                    <span
                                      class="d-none d-sm-inline-block"
                                      v-if="ioe._source.running_vm == 'vm1'"
                                      >Windows XP</span
                                    >
                                    <span
                                      class="d-none d-sm-inline-block"
                                      v-if="ioe._source.running_vm == 'vm2'"
                                      >Windows 7</span
                                    >
                                    <span
                                      class="d-none d-sm-inline-block"
                                      v-if="ioe._source.running_vm == 'vm3'"
                                      >Windows 10</span
                                    >
                                    <span
                                      class="d-none d-sm-inline-block"
                                      v-if="ioe._source.running_vm == 'vm4'"
                                      >Windows 11</span
                                    >
                                  </template>
                                  <div class="table-responsive">
                                    <table
                                      class="table mb-0"
                                      style="border-top: none"
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            width="20%"
                                            class="font-weight-bold"
                                            style="border-top: none"
                                          >
                                            Start Execution
                                          </td>
                                          <td style="border-top: none">
                                            {{
                                              formatDetectTime(
                                                ioe._source.detect_time
                                              )
                                            }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            Finish Execution
                                          </td>
                                          <td>
                                            {{ ioe._source.analysis_time }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            File Name
                                          </td>
                                          <td>
                                            {{ ioe._source.file_name }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            Threat Name
                                          </td>
                                          <td>
                                            {{ ioe._source.detect_name }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            Classification
                                          </td>
                                          <td>
                                            {{ ioe._source.detect_name }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            Severity
                                          </td>
                                          <td>
                                            {{ ioe._source.severity }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </b-tab>
                              </b-tabs>
                            </div>
                          </b-tab>
                          <b-tab>
                            <template v-slot:title>
                              <span class="d-inline-block d-sm-none">
                                <i class="bx bx-sitemap"></i>
                              </span>
                              <span class="d-none d-sm-inline-block mx-5 my-2"
                                >Relations</span
                              >
                            </template>
                            <div class="card-body p-0 py-3">
                              <h5 class="py-1 px-2">RELATED INFORMATION</h5>
                              <hr />
                              <div class="row px-3">
                                <div
                                  class="col-12 border border-left-0 border-right-0 border-top-0 py-3"
                                >
                                  <h5>Connected IP Address</h5>
                                </div>
                                <div class="col-12">
                                  <p class="mt-5 text-center">Data not found</p>
                                </div>
                              </div>
                              <!-- <div class="row mt-5 px-3">
                                <div
                                  class="col-12 border border-left-0 border-right-0 border-top-0 py-3"
                                >
                                  Related Files
                                </div>
                                <div class="col-12"></div>
                              </div> -->
                            </div>
                          </b-tab>

                          <b-tab>
                            <template v-slot:title>
                              <span class="d-inline-block d-sm-none">
                                <i class="bx bx-sitemap"></i>
                              </span>
                              <span class="d-none d-sm-inline-block mx-5 my-2"
                                >Screen Capture</span
                              >
                            </template>
                            <div class="card-body p-0 py-3">
                              <h5 class="py-1 px-2">SCREEN CAPTURE</h5>
                              <hr />
                              <div class="row" v-if="sr2.length == 0">
                                <div
                                  class="col-3 p-4"
                                  v-for="(sc, scidx) in sr2"
                                  :key="scidx"
                                >
                                  <span
                                    class="my-2"
                                    v-if="sc._source.running_vm == 'vm1'"
                                    >Windows XP</span
                                  >
                                  <span
                                    class="my-2"
                                    v-if="sc._source.running_vm == 'vm2'"
                                    >Windows 7</span
                                  >
                                  <span
                                    class="my-2"
                                    v-if="sc._source.running_vm == 'vm3'"
                                    >Windows 10</span
                                  >
                                  <span
                                    class="my-2"
                                    v-if="sc._source.running_vm == 'vm4'"
                                    >Windows 11</span
                                  >
                                  <span
                                    @click="
                                      modalImage(
                                        sc._source.md5sum,
                                        sc._source.running_vm
                                      )
                                    "
                                  >
                                    <img
                                      :src="
                                        sc_url_ahn +
                                        'md5=' +
                                        sc._source.md5sum +
                                        '&vm=' +
                                        sc._source.running_vm
                                      "
                                      alt=""
                                      width="100%"
                                      class="my-3"
                                    />
                                  </span>
                                </div>
                              </div>
                              <div class="row" v-else>
                                <div class="col-12">
                                  <p class="mt-5 text-center">Data not found</p>
                                </div>
                              </div>
                            </div>
                          </b-tab>

                          <b-tab>
                            <template v-slot:title>
                              <span class="d-inline-block d-sm-none">
                                <i class="bx bx-sitemap"></i>
                              </span>
                              <span class="d-none d-sm-inline-block mx-5 my-2"
                                >Suspicious Activities</span
                              >
                            </template>
                            <div class="card-body p-0">
                              <div
                                class="d-flex justify-content-between align-items-center py-1 px-2"
                              >
                                <h5 class="py-1">SUSPICIOUS ACTIVITIES</h5>
                                <div
                                  class="d-flex justify-content-end align-items-center"
                                  style="width: 20%"
                                >
                                  <span for="" class="mr-2">Running On : </span>
                                  <select
                                    style="width: 50%; float: right"
                                    class="form-control"
                                    v-model="susact_vm[id]"
                                    @change="changeSusactVm(id)"
                                  >
                                    <option
                                      v-for="(sa, saidx) in sr2"
                                      :key="saidx"
                                      :value="
                                        sa._source.md5sum +
                                        '_' +
                                        sa._source.running_vm
                                      "
                                    >
                                      <span
                                        v-if="sa._source.running_vm == 'vm1'"
                                        >Windows XP</span
                                      >
                                      <span
                                        v-if="sa._source.running_vm == 'vm2'"
                                        >Windows 7</span
                                      >
                                      <span
                                        v-if="sa._source.running_vm == 'vm3'"
                                        >Windows 10</span
                                      >
                                      <span
                                        v-if="sa._source.running_vm == 'vm4'"
                                        >Windows 11</span
                                      >
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <hr />
                              <div class="row mt-4">
                                <div class="col-sm-12 col-md-6">
                                  <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                  >
                                    <label
                                      class="d-inline-flex align-items-center"
                                    >
                                      {{ $t("table.show_label") }}&nbsp;&nbsp;
                                      <b-form-select
                                        v-model="perPage"
                                        size="sm"
                                        :options="pageOptions"
                                        class="mx-1"
                                      ></b-form-select
                                      >&nbsp;&nbsp;{{ $t("table.entri_label") }}
                                    </label>
                                  </div>
                                </div>
                                <!-- Search -->
                                <div class="col-sm-12 col-md-6">
                                  <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-right"
                                  >
                                    <label
                                      class="d-inline-flex align-items-center"
                                    >
                                      {{ $t("table.search_label") }}:
                                      <b-form-input
                                        v-model="filter"
                                        type="search"
                                        :placeholder="$t('navbar.search.text')"
                                        class="form-control form-control-sm ml-2"
                                      ></b-form-input>
                                    </label>
                                    <span
                                      class="ml-4 mr-2 custom-icon"
                                      title="Download File XML"
                                      @click="downloadAnalysisFile(id)"
                                    >
                                      <i
                                        class="bx bx-cloud-download bx-sm font-size-16 align-middle"
                                      ></i>
                                    </span>
                                  </div>
                                </div>
                                <!-- End search -->
                              </div>
                              <div class="table-responsive mb-0">
                                <div
                                  class="text-center mt-5"
                                  v-if="loading.change_susact_vm"
                                >
                                  <i
                                    class="bx bx-loader-circle bx-spin bx-md"
                                  ></i>
                                  <h5>Loading....</h5>
                                </div>
                                <b-table
                                  v-if="!loading.change_susact_vm"
                                  :items="table_susact[id]"
                                  :fields="fields"
                                  responsive="sm"
                                  :per-page="perPage"
                                  :current-page="currentPage"
                                  :sort-desc.sync="sortDesc"
                                  :filter="filter"
                                  :filter-included-fields="filterOn"
                                  @filtered="onFiltered"
                                  show-empty
                                >
                                  <template #cell(no)="row">
                                    <span>{{ row.item.no + 1 }}</span>
                                  </template>
                                  <template #cell(actionData.actionTime)="row">
                                    <span>
                                      {{
                                        formatTime(
                                          row.item.actionData.actionTime
                                        )
                                      }}</span
                                    >
                                  </template>
                                  <template #empty="scope">
                                    <p class="mt-5 text-center">
                                      Data not found
                                    </p>
                                  </template>
                                </b-table>
                              </div>
                              <div
                                class="row"
                                v-if="
                                  !loading.change_susact_vm &&
                                  rows(susact_vm[id]) > 10
                                "
                              >
                                <div class="col-2">
                                  <label
                                    class="d-inline-flex align-items-center"
                                  >
                                    Page
                                    <b-form-input
                                      v-model="currentPage"
                                      placeholder="Page"
                                      class="form-control w-10 form-control ml-2"
                                    ></b-form-input>
                                  </label>
                                </div>
                                <div
                                  class="col-10 text-right"
                                  v-if="rows(susact_vm[id]) > 10"
                                >
                                  <div
                                    class="dataTables_paginate paging_simple_numbers float-right"
                                  >
                                    <ul
                                      class="pagination pagination-rounded mb-0"
                                      :class="
                                        theme == 'dark'
                                          ? 'custom-paginate-dark'
                                          : 'custom-paginate'
                                      "
                                    >
                                      <b-pagination
                                        v-model="currentPage"
                                        :total-rows="rows(susact_vm[id])"
                                        :per-page="perPage"
                                      ></b-pagination>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-tab>
                        </b-tabs>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
          <div class="py-4" v-else>
            <div class="text-center">
              <img
                src="@/assets/images/no-results.png"
                alt
                height="150"
              /><br />
              <span class="font-size-16"> Not Found </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-ip-reputation"
      centered
      size="lg"
      :title="'IP Reputation Check'"
      title-class="font-18"
      hide-footer
    >
      <div v-if="loading.checkip" class="text-center">
        <i class="bx bx-loader-circle bx-spin bx-lg"></i>
        <h4>Checking ...</h4>
      </div>
      <div v-else>
        <table class="table table-borderless" v-if="ip_reputation">
          <tr>
            <th colspan="2" width="50%">IP Address</th>
            <td colspan="2" width="50%">{{ ip_reputation.ip_address }}</td>
          </tr>
          <tr>
            <th colspan="2" width="50%">Risk Score</th>
            <td colspan="2" width="50%">
              {{ ip_reputation.risk_score }} |
              <span
                class="badge badge-soft-success px-2 py-1"
                :class="{
                  'badge-soft-success': `${ip_reputation.risk_level}` == 'low',
                  'badge-soft-warning':
                    `${ip_reputation.risk_level}` == 'medium',
                  'badge-soft-danger': `${ip_reputation.risk_level}` == 'high',
                }"
                >{{ ip_reputation.risk_level }}</span
              >
            </td>
          </tr>

          <tr>
            <th colspan="2" width="50%">CIDR</th>
            <td colspan="2" width="50%">
              {{ ip_reputation.detail_data.cidr }}
            </td>
          </tr>
          <tr>
            <th colspan="2" width="50%">ASN</th>
            <td colspan="2" width="50%">{{ ip_reputation.detail_data.asn }}</td>
          </tr>

          <tr>
            <th colspan="2" class="border-bottom p-0 pl-2 pt-4">
              <h5>Geo IP</h5>
            </th>
            <td colspan="2" class="border-bottom"></td>
          </tr>
          <tr>
            <th colspan="2" width="20%">Country</th>
            <td colspan="2" width="30%">
              {{ ip_reputation.detail_data.country }}
            </td>
          </tr>
          <tr>
            <th colspan="2" width="20%">Country Code</th>
            <td colspan="2" width="30%">
              {{ ip_reputation.detail_data.country_code }}
            </td>
          </tr>
          <tr>
            <th colspan="2" width="20%">Country Calling Code</th>
            <td colspan="2" width="30%">
              {{ ip_reputation.detail_data.country_calling_code }}
            </td>
          </tr>
          <tr>
            <th colspan="2" width="20%">Continent</th>
            <td colspan="2" width="30%">
              {{ ip_reputation.detail_data.continent }}
            </td>
          </tr>
          <tr>
            <th colspan="2" width="20%">Continent Code</th>
            <td colspan="2" width="30%">
              {{ ip_reputation.detail_data.continent_code }}
            </td>
          </tr>
          <tr>
            <th colspan="2" width="20%">Region</th>
            <td colspan="2" width="30%">
              {{ ip_reputation.detail_data.region }}
            </td>
          </tr>
          <tr>
            <th colspan="2" width="20%">Region Code</th>
            <td colspan="2" width="30%">
              {{ ip_reputation.detail_data.region_code }}
            </td>
          </tr>
          <tr>
            <th colspan="2" width="20%">City</th>
            <td colspan="2" width="30%">
              {{ ip_reputation.detail_data.city }}
            </td>
          </tr>
          <tr>
            <th colspan="2" class="border-bottom p-0 pl-2 pt-4">
              <h5>Time Zone</h5>
            </th>
            <td colspan="3" class="border-bottom"></td>
          </tr>
          <tr>
            <th colspan="2" width="20%">Time Zone</th>
            <td colspan="2" width="30%">
              {{ ip_reputation.detail_data.time_zone }}
            </td>
          </tr>
          <tr>
            <th colspan="2" width="20%">Time Zone Short</th>
            <td colspan="2" width="30%">
              {{ ip_reputation.detail_data.time_zone_short }}
            </td>
          </tr>
          <tr>
            <th colspan="2" width="20%">Offset</th>
            <td colspan="2" width="30%">
              {{ ip_reputation.detail_data.time_zone_offset }}
            </td>
          </tr>
          <tr>
            <th colspan="2" width="20%">Is Dst</th>
            <td colspan="2" width="30%">
              {{ ip_reputation.detail_data.time_zone_is_dst }}
            </td>
          </tr>
          <tr>
            <th class="border-bottom p-0 pl-2 pt-4">
              <h5>IP Type</h5>
            </th>
            <td colspan="3" class="border-bottom"></td>
          </tr>
          <tr>
            <th width="20%">Data Center</th>
            <td width="30%">
              {{ ip_reputation.detail_data.is_datacenter ? "Yes" : "No" }}
            </td>
            <th width="20%">ISP</th>
            <td width="30%">
              {{ ip_reputation.detail_data.is_isp ? "Yes" : "No" }}
            </td>
          </tr>
          <tr>
            <th width="20%">Educational</th>
            <td width="30%">
              {{ ip_reputation.detail_data.is_educational ? "Yes" : "No" }}
            </td>
            <th width="20%">Military</th>
            <td width="30%">
              {{ ip_reputation.detail_data.is_military ? "Yes" : "No" }}
            </td>
          </tr>
          <tr>
            <th width="20%">Government</th>
            <td width="30%">
              {{ ip_reputation.detail_data.is_government ? "Yes" : "No" }}
            </td>
            <th width="20%">Business</th>
            <td width="30%">
              {{ ip_reputation.detail_data.is_business ? "Yes" : "No" }}
            </td>
          </tr>
          <tr>
            <th width="20%">VPN Proxy</th>
            <td width="30%">
              {{ ip_reputation.detail_data.is_vpn_proxy ? "Yes" : "No" }}
            </td>
            <th width="20%">Tor</th>
            <td width="30%">
              {{ ip_reputation.detail_data.is_tor ? "Yes" : "No" }}
            </td>
          </tr>
          <tr>
            <th width="20%">Malicious</th>
            <td width="30%">
              {{ ip_reputation.detail_data.is_malicious ? "Yes" : "No" }}
            </td>
            <th width="20%">Abusive</th>
            <td width="30%">
              {{ ip_reputation.detail_data.is_abusive ? "Yes" : "No" }}
            </td>
          </tr>
          <tr>
            <th width="20%">Bogon</th>
            <td width="30%">
              {{ ip_reputation.detail_data.is_bogon ? "Yes" : "No" }}
            </td>
          </tr>
        </table>
      </div>
    </b-modal>

    <b-modal
      id="modal-ip-whois"
      centered
      size="lg"
      :title="'IP Whois Check'"
      title-class="font-18"
      hide-footer
    >
      <div v-if="loading.whois" class="text-center">
        <i class="bx bx-loader-circle bx-spin bx-lg"></i>
        <h4>Checking ...</h4>
      </div>
      <div v-else>
        <table class="table table-borderless" v-if="whois">
          <tr>
            <th colspan="2" width="30%">IP Address</th>
            <td colspan="2" width="70%">
              <span v-if="whois.ip_address">{{ whois.ip_address }}</span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Type</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data">{{ whois.whois_data.type }} </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%" class="border-bottom">Domain</th>
            <td colspan="2" width="70%" class="border-bottom">
              <span v-if="whois.domain">{{ whois.domain }}</span>
            </td>
          </tr>
          <h6 class="mt-3">Whois Info</h6>
          <tr>
            <th colspan="2" width="30%">Registrar</th>
            <td colspan="2" width="70%">
              <span v-if="whois.domain">{{ whois.whois_data.registrar }}</span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Created Date</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data"
                ><span v-if="whois.whois_data.creation_date.length > 2">{{
                  formatDate(whois.whois_data.creation_date)
                }}</span>
                <span v-else> {{ whois.whois_data.creation_date }} </span>
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Updated Date</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data"
                ><span v-if="whois.whois_data.updated_date.length > 2">{{
                  formatDate(whois.whois_data.updated_date)
                }}</span>
                <span v-else> {{ whois.whois_data.updated_date }} x</span>
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Expiration Date</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data"
                ><span v-if="whois.whois_data.expiration_date.length > 2">{{
                  formatDate(whois.whois_data.expiration_date)
                }}</span>
                <span v-else> {{ whois.whois_data.expiration_date }} </span>
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Whois Server</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data"
                >{{ whois.whois_data.whois_server }}
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%" class="border-bottom">Name Server</th>
            <td colspan="2" width="70%" class="border-bottom">
              <span v-if="whois.whois_data"
                >{{ whois.whois_data.name_servers }}
              </span>
            </td>
          </tr>
          <h6 class="mt-3">Connection</h6>
          <tr>
            <th colspan="2" width="30%">ASN</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data.connection">
                {{ whois.whois_data.connection.asn }}
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Org</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data.connection">
                {{ whois.whois_data.connection.org }}
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%" class="border-bottom">ISP</th>
            <td colspan="2" width="70%" class="border-bottom">
              <span v-if="whois.whois_data.connection">
                {{ whois.whois_data.connection.isp }}
              </span>
            </td>
          </tr>

          <h6 class="mt-3">Geo Location</h6>
          <tr>
            <th colspan="2" width="30%">Continent</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data">
                {{ whois.whois_data.continent }} ({{
                  whois.whois_data.continent_code
                }})
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Country</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data">
                {{ whois.whois_data.country }} (
                {{ whois.whois_data.country_code }})
              </span>
              <span v-if="whois.whois_data.flag">
                <img
                  :src="whois.whois_data.flag.img"
                  alt="flag"
                  width="20"
                  class="ml-2"
              /></span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Continent</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data">
                {{ whois.whois_data.continent }}
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Region</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data">
                {{ whois.whois_data.region }} (
                {{ whois.whois_data.region_code }})
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">City</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data"> {{ whois.whois_data.city }} </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Latitude</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data">
                {{ whois.whois_data.latitude }}
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Longitude</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data">
                {{ whois.whois_data.longitude }}
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Postal</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data">
                {{ whois.whois_data.postal }}
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Capital</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data">
                {{ whois.whois_data.capital }}
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%">Borders</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data">
                {{ whois.whois_data.borders }}
              </span>
            </td>
          </tr>
          <tr>
            <th colspan="2" width="30%" class="border-bottom">Timezone</th>
            <td colspan="2" width="70%" class="border-bottom">
              <span v-if="whois.whois_data.timezone">
                {{ whois.whois_data.timezone.id }}
              </span>
            </td>
          </tr>

          <h6 v-if="whois.whois_data.security !== '-'" class="mt-2">
            Security
          </h6>
          <tr v-if="whois.whois_data.security !== '-'">
            <th colspan="2" width="30%">Anonymous</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data.security">
                {{ whois.whois_data.security.anonymous }}
              </span>
            </td>
          </tr>
          <tr v-if="whois.whois_data.security !== '-'">
            <th colspan="2" width="30%">Proxy</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data.security">
                {{ whois.whois_data.security.proxy }}
              </span>
            </td>
          </tr>
          <tr v-if="whois.whois_data.security !== '-'">
            <th colspan="2" width="30%">VPN</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data.security">
                {{ whois.whois_data.security.vpn }}
              </span>
            </td>
          </tr>
          <tr v-if="whois.whois_data.security !== '-'">
            <th colspan="2" width="30%">Tor</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data.security">
                {{ whois.whois_data.security.tor }}
              </span>
            </td>
          </tr>
          <tr v-if="whois.whois_data.security !== '-'">
            <th colspan="2" width="30%">Hosting</th>
            <td colspan="2" width="70%">
              <span v-if="whois.whois_data.security.hosting">
                {{ whois.whois_data.security.hosting }}
              </span>
            </td>
          </tr>
        </table>
      </div>
    </b-modal>

    <b-modal
      id="modal-image-capture"
      centered
      size="lg"
      :title="'Screen Capture'"
      title-class="font-18"
      hide-footer
    >
      <div class="text-center">
        <img
          :src="sc_url_ahn + 'md5=' + capture_src + '&vm=' + capture_vm"
          alt=""
          width="100%"
          class="my-3 rounded shadow"
        />
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import vue2Dropzone from "vue2-dropzone";
import { projectData } from "./data-projects";
import { malwareData1, malwareData2 } from "./data-malware";
import ReportService from "@/helpers/report.service";
import ElasticService from "@/helpers/elastic.service";
import StatisticsService from "@/helpers/statistics.service";
import IpAddressService from "@/helpers/ipaddress.service";
import WhoisService from "@/helpers/whois.service";
import { userService } from "@/helpers/authservice/user.service";
import PreferencesServices from "@/helpers/preferences.service";
import MalwareServices from "@/helpers/malware.service";
import QueueService from "@/helpers/queue.service";
import UploadMalware from "./upload-malware.vue";
import QueueAnalysis from "./queue-analysis.vue";
import HistoryUpload from "./history-upload.vue";
import moment from "moment";
import Helpers from "@/helpers/auxiliary.function";
import { notificationMethods } from "@/state/helpers";
import _ from "lodash";

/**
 * Projects-grid component
 */
export default {
  page: {
    title: "Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    vueDropzone: vue2Dropzone,
    Layout,
    PageHeader,
    HistoryUpload,
    UploadMalware,
    QueueAnalysis,
  },
  data() {
    return {
      id_search: this.$route.query.search,
      sc_url_cp: process.env.VUE_APP_BASE_API_URL_SCREENCAPTURE_CP,
      sc_url_ahn: process.env.VUE_APP_BASE_API_URL_SCREENCAPTURE_AHN,
      pref_search_ip: {
        id_pref: "",
        type: "",
        key: "",
        api_name: "",
        api_host: "",
        api_header_host: "",
        api_header_key: "",
      },
      pref_search_whois: {
        id_pref: "",
        type: "",
        key: "",
        api_name: "",
        api_host: "",
        api_header_host: "",
        api_header_key: "",
      },
      pref_search_whois2: {
        id_pref: "",
        type: "",
        key: "",
        api_name: "",
        api_host: "",
        api_header_host: "",
        api_header_key: "",
      },
      malwareData1: malwareData1,
      malwareData2: malwareData2,
      projectData: projectData,
      role: this.$store.state.authBackend.role,
      title: "LAB MALWARE",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Malware",
          active: true,
        },
      ],
      capture_src: "",
      capture_vm: "",
      sandbox_value: "all",
      center: { lat: -2.687944013464189, lng: 117.81568343337175 },
      zoom: 5,
      poi: false,
      theme: localStorage.getItem("theme") ?? "light",
      isShow: false,
      isSearch: false,
      loading: {
        search: false,
        checkip: false,
        whois: false,
        susact: {},
        change_susact_vm: false,
        change_cp_susact_vm: false,
        ioe: false,
      },
      form: {
        searchKey: "",
        advanced: {
          file_name: "",
          threat_name: "",
          file_type: "",
          ip_address: "",
          md5: "",
          sha1: "",
        },
      },
      searchResult1: [],
      detailInfo: [],
      searchResult2: [],
      ip_elastic: "http://10.10.30.249:9200/",
      ip_elastic_cp: "",
      ip_elastic_ahn: "",
      ip_reputation: "",
      whois: "",
      fileValid: true,
      runqueue: false,
      suspicious_activity: {},
      susact_vm: {},
      table_susact: {},
      cp_suspicious_activity: {},
      cp_susact_vm: {},
      cp_table_susact: {},

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "2%" },
          label: "No",
        },
        {
          key: "actionData.@attributes.actionCategory",
          class: "text-left",
          thStyle: { width: "10%" },
          label: "Category",
        },
        {
          key: "actionData.actionTime",
          sortable: true,
          label: "Time",
        },
        {
          key: "actionData.message.description",
          sortable: true,
          label: "Description",
        },
      ],
      fields_cp: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "2%" },
          label: "No",
        },
        {
          key: "category",
          class: "text-left",
          thStyle: { width: "10%" },
          label: "Category",
        },
        {
          key: "count",
          sortable: true,
          label: "Count",
        },
        {
          key: "description",
          sortable: true,
          label: "Description",
        },
      ],
    };
  },
  computed: {},
  methods: {
    rows(id) {
      return this.suspicious_activity[id] &&
        this.suspicious_activity[id].data.length != 0
        ? this.suspicious_activity[id].data.length
        : 0;
    },
    rowscp(id) {
      return this.cp_suspicious_activity[id] &&
        this.cp_suspicious_activity[id].data.length != 0
        ? this.cp_suspicious_activity[id].data.length
        : 0;
    },
    changeSusactVm(id) {
      let idSusact = this.susact_vm[id];
      const tableSusact = Object.fromEntries([
        [
          id,
          this.suspicious_activity[idSusact] &&
          this.suspicious_activity[idSusact].data.length != 0
            ? this.suspicious_activity[idSusact].data
            : [],
        ],
      ]);
      Object.assign(this.table_susact, tableSusact);

      this.loading.change_susact_vm = true;

      setTimeout(() => {
        this.loading.change_susact_vm = false;
      }, 1000);
    },
    changeCpSusactVm(id) {
      let idSusact = this.cp_susact_vm[id];
      const tableCpSusact = Object.fromEntries([
        [
          id,
          this.cp_suspicious_activity[idSusact] &&
          this.cp_suspicious_activity[idSusact].data.length != 0
            ? this.cp_suspicious_activity[idSusact]
            : [],
        ],
      ]);
      Object.assign(this.cp_table_susact, tableCpSusact);
      this.loading.change_cp_susact_vm = true;

      setTimeout(() => {
        this.loading.change_cp_susact_vm = false;
      }, 1000);
    },
    getPreferences() {
      let ferr = 0;
      PreferencesServices.getPreference()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPreferences();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.totalUser = [];
            let pref = response.data.data;

            pref.forEach((val) => {
              if (val.key == "ip_reputation") {
                this.pref_search_ip = {
                  id_pref: val.id_pref,
                  type: val.type,
                  key: val.key,
                  api_name: val.api_name,
                  api_host: val.api_host,
                  api_header_host: val.api_header_host,
                  api_header_key: val.api_header_key,
                };
              } else if (val.key == "whois") {
                this.pref_search_whois = {
                  id_pref: val.id_pref,
                  type: val.type,
                  key: val.key,
                  api_name: val.api_name,
                  api_host: val.api_host,
                  api_header_host: val.api_header_host,
                  api_header_key: val.api_header_key,
                };
              } else if (val.key == "whois2") {
                this.pref_search_whois2 = {
                  id_pref: val.id_pref,
                  type: val.type,
                  key: val.key,
                  api_name: val.api_name,
                  api_host: val.api_host,
                  api_header_host: val.api_header_host,
                  api_header_key: val.api_header_key,
                };
              }
            });
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPreferences();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },

    getPreferencesCp() {
      PreferencesServices.getByKey("elastic", "checkpoint")
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPreferencesCp();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.ip_elastic_cp = response.data.data;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPreferencesCp();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        });
    },

    getPreferencesAhn() {
      PreferencesServices.getByKey("elastic", "ahn_lab")
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPreferencesAhn();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.ip_elastic_ahn = response.data.data;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPreferencesAhn();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        });
    },

    finishUpload() {
      this.runqueue = true;
      setTimeout(() => {
        this.runqueue = false;
      }, 1500);
    },

    doSearchAfterUpload(val) {
      console.log("search do ", val);
      this.isSearch = false;
      this.loading.search = true;
      this.sandbox_value = val.sandbox;
      if (val.sandbox == "1") {
        this.status(val.malware.response.md5, val.sandbox, val);
        this.form.searchKey = val.malware.response.md5;
        this.searchCheckpoint();
      }
      if (val.sandbox == "2") {
        this.status(val.malware.id, val.sandbox, val);
        this.form.searchKey = val.malware.md5sum;
        this.searchAhnLab();
      }
      setTimeout(() => {
        this.loading.search = false;
        this.isSearch = true;
      }, 1500);
    },

    status(id_malware, sandbox, data) {
      console.log("ccheck status  ", id_malware, sandbox);
      if (sandbox == "2") {
        const bodyData = {
          id_malware: id_malware,
        };
        console.log("sand 2  ", bodyData);
        MalwareServices.ahnRequestStatus(bodyData)
          .then((res) => {
            if (res.status == 201) {
              let new_token = res.data.refresh_access_token;
              userService.splitToken(new_token);
              this.status(id_malware, sandbox, data);
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              let detailMalware = res.data.data;
              console.log("detail Malware", detailMalware);
              if (detailMalware.status == "done") {
                this.updateQueue(data, detailMalware);
              } else {
                setTimeout(() => {
                  this.status(id_malware, sandbox, data);
                }, 3000);
              }
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.status(id_malware, sandbox, data);
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log("consle ", err);
              }
            }
          });
      }
      if (sandbox == "1") {
        console.log("dataaa 000 => ", data);
        const bodyData = {
          md5: data.malware.response.md5,
          file_type: data.malware.response.file_type,
          file_name: data.malware.response.file_name,
        };
        MalwareServices.cpRequestStatus(bodyData)
          .then((res) => {
            if (res.status == 201) {
              let new_token = res.data.refresh_access_token;
              userService.splitToken(new_token);
              this.status(id_malware, sandbox, data);
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              let detailMalware = res.data.data;
              if (
                detailMalware.response.te.images[0].status != "pending" &&
                detailMalware.response.te.images[1].status != "pending"
              ) {
                this.updateQueue(data, detailMalware);
              } else {
                setTimeout(() => {
                  this.status(id_malware, sandbox, data);
                }, 3000);
              }
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.status(id_malware, sandbox, data);
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log("err ->> ", err);
              }
            }
          });
      }
    },

    updateQueue(data, detailMalware) {
      let bodyData = [];
      if (data.sandbox == 1) {
        bodyData = {
          md5: data.malware.response.md5,
          running_vm: data.running_vm,
          sandbox: data.sandbox == "1" ? "cp_lab" : "ahn_lab",
        };
      }
      if (data.sandbox == 2) {
        bodyData = {
          md5: data.malware.md5sum,
          running_vm: data.running_vm,
          sandbox: data.sandbox == "1" ? "cp_lab" : "ahn_lab",
        };
      }
      QueueService.detail(bodyData)
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.updateQueue(data, detailMalware);
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            const dataQueue = res.data.data;
            console.log("data ", dataQueue);
            console.log("data 2", detailMalware);
            if (dataQueue.sandbox == "ahn_lab") {
              this.storeToElasticAhn(detailMalware, dataQueue);
            }
            if (dataQueue.sandbox == "cp_lab") {
              this.storeToElasticCp(detailMalware, dataQueue);
              if (detailMalware.response.te.summary_report != "") {
                this.decodeReport(
                  detailMalware.response.md5,
                  detailMalware.response.te.summary_report
                );
              }
            }
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.updateQueue(data, detailMalware);
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              //**  handle response failed here
              console.log("err update Queue : => ", err);
            }
          }
        });
    },

    downloadFile(downloadlist, id_malware) {
      downloadlist.forEach((element) => {
        if (element != "file") {
          const dwData = {
            id_malware: id_malware,
          };
          MalwareServices.ahnAnalysisFile(element, dwData)
            .then((res) => {
              if (res.status == 201) {
                let new_token = res.data.refresh_access_token;
                userService.splitToken(new_token);
                this.downloadAnalysisFile(downloadlist, id_malware);
                this.$store.dispatch("notification/refreshtoken", "refresh");
              } else {
                console.log(
                  "succ download " + element + " malware : " + id_malware,
                  res
                );
              }
            })
            .catch((err) => {
              if (err.response == undefined) {
                console.log("err ->> ", err);
              } else if (
                this.$store.state.notification.type === "refresh-token" &&
                err.response.status == 401
              ) {
                this.downloadAnalysisFile(downloadlist, id_malware);
              } else {
                if (err.response.status == 401) {
                  userService.logout();
                } else {
                  //**  handle response failed here
                  console.log(
                    "fail download " + element + " malware : " + id_malware,
                    err
                  );
                }
              }
            });
        }
      });
    },

    storeToElasticAhn(malware, queue) {
      if (this.ip_elastic_ahn.username && this.ip_elastic_ahn.password) {
        let usps =
          this.ip_elastic_ahn.username + ":" + this.ip_elastic_ahn.password;
        let base = Helpers.encode(usps);
        var basedata_ahn = "Basic " + base + "";
      } else {
        var basedata_ahn = null;
      }
      const ipHost =
        this.ip_elastic_ahn.api_host +
        "_doc/" +
        malware.md5sum +
        "_" +
        queue.running_vm;
      let malwareData = {
        id: malware.id,
        detect_time: malware.detect_time,
        status: malware.status,
        md5sum: malware.md5sum,
        file_name: malware.file_name,
        file_type: malware.file_type,
        detect_name: malware.detect_name,
        file_size: malware.file_size,
        severity: malware.severity,
        my_id: malware.my_id,
        parent_id: malware.parent_id,
        unknown: malware.unknown,
        download: malware.download,
        related: malware.related,
        running_vm: queue.running_vm,
        analysis_time: queue.analysis_time,
      };

      ElasticService.storeAhnLab(ipHost, malwareData, basedata_ahn)
        .then((res) => {
          console.log("store elastic success", res);
        })
        .catch((err) => {
          console.log("store elastic failed", err);
        });
    },

    storeToElasticCp(malware, queue) {
      if (this.ip_elastic_cp.username && this.ip_elastic_cp.password) {
        let usps =
          this.ip_elastic_cp.username + ":" + this.ip_elastic_cp.password;
        let base = Helpers.encode(usps);
        var basedata_cp = "Basic " + base + "";
      } else {
        var basedata_cp = null;
      }

      const ipHost = this.ip_elastic_cp.api_host + "_doc/" + queue.md5;
      const malwareData = {
        ...malware.response,
        ...{
          detect_time: queue.created_at,
          analysis_time: queue.analysis_time,
        },
      };
      // console.log("store elastic CP =>>  ", malwareData);
      ElasticService.storeCpLab(ipHost, malwareData, basedata_cp)
        .then((res) => {
          console.log("store elastic success", res);
        })
        .catch((err) => {
          console.log("store elastic failed", err);
        });
    },

    decodeReport(md5, id_report) {
      const bodyData = {
        md5: md5,
        id_report: id_report,
      };

      MalwareServices.decodeReport(bodyData)
        .then((res) => {
          console.log("decode ", res);
        })
        .catch((err) => {
          console.log("decode err ", err);
        });
    },

    dummySearch() {
      if (this.form.searchKey != "") {
        this.isSearch = false;
        this.loading.search = true;
        if (this.sandbox_value == "1" || this.sandbox_value == "all") {
          this.searchCheckpoint();
        }
        if (this.sandbox_value == "2" || this.sandbox_value == "all") {
          this.searchAhnLab();
        }
        setTimeout(() => {
          this.loading.search = false;
          this.isSearch = true;
        }, 1500);
      }
    },
    dummyAdvancedSearch() {
      if (
        this.form.advanced.file_name != "" ||
        this.form.advanced.threat_name != "" ||
        this.form.advanced.file_type != "" ||
        this.form.advanced.ip_address != "" ||
        this.form.advanced.md5 != "" ||
        this.form.advanced.sha1 != ""
      ) {
        this.isSearch = false;
        this.loading.search = true;
        if (this.sandbox_value == "1" || this.sandbox_value == "all") {
          this.searchCheckpoint(true);
        }
        if (this.sandbox_value == "2" || this.sandbox_value == "all") {
          this.searchAhnLab(true);
        }
        setTimeout(() => {
          this.loading.search = false;
          this.isSearch = true;
        }, 1500);
      }
    },
    searchCheckpoint(advanced = false) {
      let bodyQuery = {
        size: 100,
        query: {
          bool: {
            filter: [],
            should: [],
            must_not: [],
          },
        },
      };

      if (!advanced) {
        const optionQuery = {
          bool: {
            should: [
              {
                bool: {
                  should: [
                    {
                      query_string: {
                        fields: ["file_name"],
                        query: "*" + this.form.searchKey + "*",
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
              {
                bool: {
                  should: [
                    {
                      bool: {
                        should: [
                          {
                            match: {
                              md5: this.form.searchKey,
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                    {
                      bool: {
                        should: [
                          {
                            bool: {
                              should: [
                                {
                                  query_string: {
                                    fields: ["av.malware_info.signature_name"],
                                    query: "*" + this.form.searchKey + "*",
                                  },
                                },
                              ],
                              minimum_should_match: 1,
                            },
                          },
                          {
                            bool: {
                              should: [
                                {
                                  bool: {
                                    should: [
                                      {
                                        match: {
                                          sha1: this.form.searchKey,
                                        },
                                      },
                                    ],
                                    minimum_should_match: 1,
                                  },
                                },
                                {
                                  bool: {
                                    should: [
                                      {
                                        match: {
                                          sha256: this.form.searchKey,
                                        },
                                      },
                                    ],
                                    minimum_should_match: 1,
                                  },
                                },
                              ],
                              minimum_should_match: 1,
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        bodyQuery.query.bool.filter.push(optionQuery);
      }

      if (advanced) {
        const optionQuery = {
          bool: {
            should: [
              {
                bool: {
                  should: [
                    {
                      query_string: {
                        fields: ["file_name"],
                        query: "*" + this.form.advanced.file_name + "*",
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
              {
                bool: {
                  should: [
                    {
                      bool: {
                        should: [
                          {
                            match: {
                              md5: this.form.advanced.md5,
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                    {
                      bool: {
                        should: [
                          {
                            bool: {
                              should: [
                                {
                                  match: {
                                    file_type: this.form.advanced.file_type,
                                  },
                                },
                              ],
                              minimum_should_match: 1,
                            },
                          },
                          {
                            bool: {
                              should: [
                                {
                                  bool: {
                                    should: [
                                      {
                                        query_string: {
                                          fields: [
                                            "av.malware_info.signature_name",
                                          ],
                                          query:
                                            this.form.advanced.threat_name == ""
                                              ? ""
                                              : "*" +
                                                this.form.advanced.threat_name +
                                                "*",
                                        },
                                      },
                                    ],
                                    minimum_should_match: 1,
                                  },
                                },
                                {
                                  bool: {
                                    should: [
                                      {
                                        match: {
                                          sha1: this.form.advanced.sha1,
                                        },
                                      },
                                    ],
                                    minimum_should_match: 1,
                                  },
                                },
                              ],
                              minimum_should_match: 1,
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        bodyQuery.query.bool.filter.push(optionQuery);
      }

      if (this.ip_elastic_cp.username && this.ip_elastic_cp.password) {
        let usps =
          this.ip_elastic_cp.username + ":" + this.ip_elastic_cp.password;
        let base = Helpers.encode(usps);
        var basedata_cp = "Basic " + base + "";
      } else {
        var basedata_cp = null;
      }

      ElasticService.getCheckpointLab(
        this.ip_elastic_cp.api_host,
        bodyQuery,
        basedata_cp
      )
        .then((response) => {
          this.searchResult1 = response.data.hits.hits;
          this.detailInfo = [];
          this.searchResult1.forEach((el) => {
            this.getDetailInfo(el._source.md5);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searchAhnLab(advanced = false) {
      let bodyQuery = {
        size: 100,
        query: {
          bool: {
            filter: [],
            should: [],
            must_not: [],
          },
        },
      };

      if (!advanced) {
        if (this.id_search) {
          var optionQuery = {
            bool: {
              should: [
                {
                  bool: {
                    should: [
                      {
                        match_phrase: {
                          detect_name: this.form.searchKey,
                        },
                      },
                    ],
                    minimum_should_match: 1,
                  },
                },
              ],
              minimum_should_match: 1,
            },
          };
        } else {
          {
            var optionQuery = {
              bool: {
                should: [
                  {
                    bool: {
                      should: [
                        {
                          query_string: {
                            fields: ["detect_name"],
                            query: "*" + this.form.searchKey + "*",
                          },
                        },
                      ],
                      minimum_should_match: 1,
                    },
                  },
                  {
                    bool: {
                      should: [
                        {
                          match_phrase: {
                            md5sum: this.form.searchKey,
                          },
                        },
                      ],
                      minimum_should_match: 1,
                    },
                  },
                  {
                    bool: {
                      should: [
                        {
                          query_string: {
                            fields: ["file_name"],
                            query: "*" + this.form.searchKey + "*",
                          },
                        },
                      ],
                      minimum_should_match: 1,
                    },
                  },
                ],
                minimum_should_match: 1,
              },
            };
          }
        }
        bodyQuery.query.bool.filter.push(optionQuery);
      }

      if (advanced) {
        const optionQuery = {
          bool: {
            should: [
              {
                bool: {
                  should: [
                    {
                      query_string: {
                        fields: ["detect_name"],
                        query: "*" + this.form.advanced.threat_name + "*",
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
              {
                bool: {
                  should: [
                    {
                      bool: {
                        should: [
                          {
                            query_string: {
                              fields: ["file_name"],
                              query: "*" + this.form.advanced.file_name + "*",
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                    {
                      bool: {
                        should: [
                          {
                            bool: {
                              should: [
                                {
                                  match_phrase: {
                                    file_type: this.form.advanced.file_type,
                                  },
                                },
                              ],
                              minimum_should_match: 1,
                            },
                          },
                          {
                            bool: {
                              should: [
                                {
                                  match_phrase: {
                                    md5sum: this.form.advanced.md5,
                                  },
                                },
                              ],
                              minimum_should_match: 1,
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        bodyQuery.query.bool.filter.push(optionQuery);
      }

      if (this.ip_elastic_ahn.username && this.ip_elastic_ahn.password) {
        let usps =
          this.ip_elastic_ahn.username + ":" + this.ip_elastic_ahn.password;
        let base = Helpers.encode(usps);
        var basedata_ahn = "Basic " + base + "";
      } else {
        var basedata_ahn = null;
      }

      ElasticService.getAhnLab(
        this.ip_elastic_ahn.api_host,
        bodyQuery,
        basedata_ahn
      )
        .then((response) => {
          this.searchResult2 = _.groupBy(response.data.hits.hits, "_source.id");
          let grouped = _.groupBy(response.data.hits.hits, "_source.md5sum");

          this.setDefaultSusact(grouped);
          // get suspicious activity if exist in download list
          response.data.hits.hits.forEach((el) => {
            if (el._source.download.includes("dica")) {
              this.getSuspiciousActivity(
                "1",
                el._source.md5sum,
                el._source.running_vm
              );
            }
            if (el._source.download.includes("mdp")) {
              this.getSuspiciousActivity(
                "2",
                el._source.md5sum,
                el._source.running_vm
              );
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    setDefaultSusact(grouped) {
      Object.keys(grouped).forEach((ele) => {
        // make default selected vm suspicious activity
        const defaultSusact = Object.fromEntries([
          [
            ele,
            grouped[ele][0]._source.md5sum +
              "_" +
              grouped[ele][0]._source.running_vm,
          ],
        ]);
        Object.assign(this.susact_vm, defaultSusact);
      });
    },

    setDefaultSusactCp(md5, grouped) {
      // make default selected vm suspicious activity
      const defaultSusactCp = Object.fromEntries([[md5, md5 + "_0"]]);
      Object.assign(this.cp_susact_vm, defaultSusactCp);

      const defaultTableSusactCp = Object.fromEntries([
        [
          md5,
          {
            image: grouped[0].image,
            data: grouped[0].behaviors.map((el, idx) => {
              return { ...el, ...{ no: idx } };
            }),
          },
        ],
      ]);
      Object.assign(this.cp_table_susact, defaultTableSusactCp);
    },

    openModalIpReputation(ipaddr) {
      this.$bvModal.show("modal-ip-reputation");
      this.loading.checkip = true;
      this.checkIpLocal(ipaddr);
    },

    openModalWhois(ipaddr) {
      this.$bvModal.show("modal-ip-whois");
      this.loading.whois = true;
      this.checkIpLocalWhois(ipaddr);
    },

    checkIpLocal(ipaddr) {
      const params = {
        ipaddr: ipaddr,
      };
      IpAddressService.checkLocal(params)
        .then((response) => {
          console.log("true");
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.checkIpLocal(ipaddr);
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            if (response.data.data) {
              const resultData = {
                ip_address: response.data.data.ip_address,
                risk_score: response.data.data.risk_score,
                risk_level: response.data.data.risk_level,
                country: response.data.data.country,
                detail_data: JSON.parse(response.data.data.detail_data),
              };
              this.ip_reputation = resultData;
              setTimeout(() => {
                this.loading.checkip = false;
              }, 2000);
            }
            if (!response.data.data) {
              this.checkIpRapid(ipaddr);
            }
          }
        })
        .catch((err) => {
          console.log("false");
          this.checkIpRapid(ipaddr);
          console.log("errr ", err);
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.checkIpLocal();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading.checkip = false;
            }
          }
        });
    },

    checkIpRapid(ipaddr) {
      const apiHost = this.pref_search_ip.api_host;
      const headers = {
        "X-RapidAPI-Key": this.pref_search_ip.api_header_key,
        "X-RapidAPI-Host": this.pref_search_ip.api_header_host,
      };
      const params = {
        ip: ipaddr,
      };
      axios
        .get(apiHost, { params: params, headers: headers })
        .then((response) => {
          console.log("res", response.data);
          this.saveIpReputation(response.data);
          this.loading.checkip = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading.checkip = false;
        });
    },

    saveIpReputation(data) {
      const dataBody = {
        ip_address: data.ip,
        risk_score: data.risk,
        risk_level: data.risk_level,
        country: data.country,
        detail_data: data,
      };
      IpAddressService.saveReputation(dataBody)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.saveIpReputation(data);
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            const resultData = {
              ip_address: response.data.data.ip_address,
              risk_score: response.data.data.risk_score,
              risk_level: response.data.data.risk_level,
              country: response.data.data.country,
              detail_data: JSON.parse(response.data.data.detail_data),
            };
            this.ip_reputation = resultData;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.saveIpReputation();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading.checkip = false;
          }
        });
    },

    showMap() {
      this.isShow = this.isShow ? false : true;
    },

    checkIpLocalWhois(ipaddr) {
      const params = {
        ipaddr: ipaddr,
      };
      let ferr = 0;
      WhoisService.checkLocal(params)
        .then((response) => {
          console.log("true");
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.checkIpLocalWhois(ipaddr);
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            if (response.data.data) {
              const resultData = {
                ip_address: response.data.data.ip_address,
                domain: response.data.data.domain,
                whois_data: JSON.parse(response.data.data.whois_data),
              };
              this.whois = resultData;
              setTimeout(() => {
                this.loading.whois = false;
              }, 2000);
            }
            if (!response.data.data) {
              this.checkIpRapidWhois(ipaddr);
            }
          }
        })
        .catch((err) => {
          console.log("false");
          this.checkIpRapid(ipaddr);
          console.log("errr ", err);
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.checkIpLocal();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading.checkip = false;
            }
          }
        });
    },

    checkIpRapidWhois(ipaddr) {
      // console.log("mulai");
      const apiHost = this.pref_search_whois.api_host;
      const headers = {
        "X-RapidAPI-Key": this.pref_search_whois.api_header_key,
        "X-RapidAPI-Host": this.pref_search_whois.api_header_host,
      };
      const params = {
        q: ipaddr,
      };
      // console.log("tes WHOIS", apiHost, headers, params);
      axios
        .get(apiHost + ipaddr)
        .then((response) => {
          // console.log("res", response.data);
          this.getDetailWhois(ipaddr, response.data);
          this.loading.whois = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading.whois = false;
        });
    },

    getDetailWhois(ipaddr, datax) {
      console.log("get whois detail");
      const domain = datax.connection.domain ?? "-";
      const data = datax;
      const apiHost = this.pref_search_whois2.api_host;

      // console.log("tes WHOIS", apiHost, headers, params);
      const dom = {
        website: domain,
      };
      const headers = {
        "Access-Control-Allow-Origin": "*",
      };
      axios
        .post(apiHost, dom, headers)
        .then((response) => {
          // console.log("res whois detail", response.data.output);
          const data2 = response.data.output;
          this.saveIpWhois(ipaddr, data, data2);
          this.loading.whois = false;
        })
        .catch((err) => {
          console.log("res whois detail err", err);
          this.loading.whois = false;
          this.saveIpWhois(ipaddr, data, "");
        });
    },

    saveIpWhois(ipaddr, data, data2) {
      // var con = JSON.stringify(data.latitude);
      const dataBody = {
        ip_address: data.ip,
        domain: data.connection.domain ?? "-",
        whois_data: {
          ip: data.ip ?? "-",
          success: data.success ?? "-",
          type: data.type ?? "-",
          continent: data.continent ?? "-",
          continent_code: data.continent_code ?? "-",
          country: data.country ?? "-",
          country_code: data.country_code ?? "-",
          region: data.region ?? "-",
          region_code: data.region_code ?? "-",
          city: data.city ?? "-",
          latitude: data.latitude ?? "-",
          longitude: data.longitude ?? "-",
          is_eu: data.is_eu ?? "-",
          postal: data.postal ?? "-",
          calling_code: data.calling_code ?? "-",
          capital: data.capital ?? "-",
          borders: data.borders ?? "-",
          flag: data.flag ?? "-",
          connection: data.connection ?? "-",
          timezone: data.timezone ?? "-",
          security: data.security ?? "-",

          creation_date: data2.creation_date ?? "-",
          expiration_date: data2.expiration_date ?? "-",
          updated_date: data2.updated_date ?? "-",
          whois_server: data2.whois_server ?? "-",
          registrar: data2.registrar ?? "-",
          name_servers: data2.name_servers ?? "-",
        },
      };
      WhoisService.saveWhois(dataBody)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.saveIpWhois(data);
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            // console.log('datax', response.data.data);
            var res = response.data.data;
            const resultData = {
              ip_address: res.ip_address,
              domain: res.domain,
              whois_data: JSON.parse(res.whois_data),
            };
            this.whois = resultData;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.saveIpWhois();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading.checkip = false;
          }
        });
    },

    getSuspiciousActivity(type, md5, vm) {
      this.loading.change_susact_vm = true;
      MalwareServices.ahnSupiciousActivity(type, md5, vm)
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getSuspiciousActivity(type, md5, vm);
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            let withIndex = [];
            if (
              typeof res.data.analysisDataGroup != undefined &&
              res.data.analysisDataGroup?.analysisData
            ) {
              withIndex = res.data.analysisDataGroup.analysisData.map(
                (el, idx) => {
                  return { ...el, ...{ no: idx } };
                }
              );
            }

            // set detail activity to variable suspicious_activity
            const susObject = Object.fromEntries([
              [md5 + "_" + vm, { data: withIndex }],
            ]);
            Object.assign(this.suspicious_activity, susObject);
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getSuspiciousActivity(type, md5, vm);
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err activity", err);
            }
          }
        })
        .finally(() => {
          // make default content table suspicious activity
          Object.keys(this.searchResult2).forEach((ele) => {
            let idSusact =
              this.searchResult2[ele][0]._source.md5sum +
              "_" +
              this.searchResult2[ele][0]._source.running_vm;

            const defaultTableSusact = Object.fromEntries([
              [
                ele,
                this.suspicious_activity[idSusact] &&
                this.suspicious_activity[idSusact].data.length != 0
                  ? this.suspicious_activity[idSusact].data
                  : [],
              ],
            ]);
            Object.assign(this.table_susact, defaultTableSusact);
          });

          setTimeout(() => {
            this.loading.change_susact_vm = false;
          }, 1000);
        });
    },

    downloadAnalysisFile(id) {
      const file_name = this.susact_vm[id];
      MalwareServices.ahnDownloadFileXml(file_name)
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.downloadAnalysisFile(id);
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            const fileURL = window.URL.createObjectURL(new Blob([res.data]));
            const fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", file_name + ".xml");
            document.body.appendChild(fileLink);

            fileLink.click();
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.downloadAnalysisFile(id);
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err download", err);
            }
          }
        });
    },

    getDetailInfo(md5) {
      const bodyData = {
        md5: md5,
      };
      this.loading.change_cp_susact_vm = true;
      MalwareServices.cpDetail(bodyData)
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getDetailInfo(md5);
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.detailInfo.push(res.data.data);
            this.setDefaultSusactCp(md5, res.data.data.suspicious_act.images);
            res.data.data.suspicious_act.images.forEach((ele, idx) => {
              // set detail activity to variable cp_suspicious_activity
              const susCpObject = Object.fromEntries([
                [
                  md5 + "_" + idx,
                  {
                    image: ele.image,
                    data: ele.behaviors.map((el, idx) => {
                      return { ...el, ...{ no: idx } };
                    }),
                  },
                ],
              ]);
              Object.assign(this.cp_suspicious_activity, susCpObject);
            });
            setTimeout(() => {
              this.loading.change_cp_susact_vm = false;
            }, 1000);
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            setTimeout(() => {
              this.loading.change_cp_susact_vm = false;
            }, 1000);
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.downloadAnalysisFile(id);
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err download", err);
              setTimeout(() => {
                this.loading.change_cp_susact_vm = false;
              }, 1000);
            }
          }
          console.log("lokal err ", err);
        });
    },

    mapTheme() {
      let darkMode = {
        styles: [
          { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#242f3e" }],
          },
          { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.business",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#38414e" }],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#212a37" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9ca5b3" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#746855" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#1f2835" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#f3d19c" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#17263c" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#515c6d" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#17263c" }],
          },
        ],
      };

      let lightMode = {
        styles: [
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
        ],
      };

      if (this.theme != "dark") {
        return lightMode;
      } else {
        return darkMode;
      }
    },
    getFileTypeIcon(key) {
      let fileicon = "unknown.png";
      switch (key) {
        case "doc":
          fileicon = "docs.png";
          break;
        case "docx":
          fileicon = "docs.png";
          break;
        case "pdf":
          fileicon = "pdf.png";
          break;
        case "exe":
          fileicon = "exe.png";
          break;
        case "text/html":
          fileicon = "html.png";
          break;
        case "html":
          fileicon = "html.png";
          break;
        case "zip":
          fileicon = "compress.png";
          break;
        case "rar":
          fileicon = "compress.png";
          break;
        case "tar":
          fileicon = "compress.png";
          break;
        case "text":
          fileicon = "txt.png";
          break;
        default:
          break;
      }
      return fileicon;
    },

    openModalWhois(ipaddr) {
      this.$bvModal.show("modal-ip-whois");
      this.loading.whois = true;
      this.checkIpLocalWhois(ipaddr);
    },

    modalImage(src, vm) {
      console.log("ic", src, vm);
      this.capture_src = src;
      this.capture_vm = vm;
      this.$bvModal.show("modal-image-capture");
    },

    copyText(text) {
      navigator.clipboard.writeText(text);
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    formatTime(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm:ss");
    },
    formatDetectTime(val) {
      return moment(val).utcOffset("+14:00").format("YYYY-MM-DD HH:mm:ss");
    },
    formatByte(val) {
      return Helpers.formatBytes(val);
    },
  },
  beforeMount() {
    this.getPreferences();
    this.getPreferencesCp();
    this.getPreferencesAhn();
  },
  mounted() {
    this.totalRows = this.items.length;
    if (this.$route.query.search) {
      this.loading.search = true;
      this.form.searchKey = this.$route.query.search;
      setTimeout(() => {
        console.log("ada");
        return this.dummySearch();
      }, 2000);
    }
  },
};
</script>
<style>
.upload-setting {
  border: solid 3px #052a38;
  border-radius: 5px;
}
.custom-icon:hover {
  cursor: pointer;
  color: #1a3fa3;
}
.page-item.active .page-link {
  background-color: #024284 !important;
  border-color: #024284 !important;
}
.custom-paginate-dark .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #022b3a !important;
}
.custom-paginate .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #eff2f7 !important;
}
</style>
